import InfoIcon from '@mui/icons-material/Info';

export const InfoIconMUI2 = InfoIcon;
